import React, { useState } from 'react';

import Link from 'components/atoms/Link';
import MemberJoinModalDesktop from 'components/molecules/MemberJoinModalDesktop';
import MemberJoinModalMobile from 'components/molecules/MemberJoinModalMobile';

import { useLogin } from 'models/login';
import history from 'store/history';

import classNames from 'classnames';
import styles from './index.module.css';

const Footer: React.FC = () => {
	// 從 store 獲取首頁已經存入 store 過的 JwtPayload 及裝置類型資料
	const [{ JwtPayload, device, isGrMember, loginLoading }, { oAuthLogin }] = useLogin();

	/* modal 手/桌機板 狀態 */
	const [showModalMobile, setShowModalMobile] = useState<boolean>(false);
	const [showModalDesktop, setShowModalDesktop] = useState<boolean>(false);
	const closeModalMobile = () => {
		setShowModalMobile(false);
	};
	const closeModalDesktop = () => {
		setShowModalDesktop(false);
	};
	/**
	 * 判斷當前開啟的瀏覽器是手機還是桌機
	 */
	// const userAgent = window.navigator.userAgent.toLowerCase();
	// const [isInitMobileBrowser] = useState<boolean>(/iphone|ipad|ipod|android/.test(userAgent));
	/* 會員功能的各種情境： */
	const memberFeatureHandler = (validLink = '') => {
		/* 桌面端不需其他處理, 只需秀桌面端 modal */
		// if (device.length === 0 && !isInitMobileBrowser) setShowModalDesktop(true);

		/* 利用手機瀏覽器(非webview) 開啟的情況 連結 Dynamic link 至 app 商店 or app首頁 */
		// if (device.length === 0 && isInitMobileBrowser) window.open(generateDynamicLink('/'));

		/* ios/Android app 開啟 webview 但沒有 token 的情況 => 利用 ios/Android team 提供方法轉導至 login 頁 */
		if (device === 'ios' && !JwtPayload)
			window.webkit?.messageHandlers.startOauth.postMessage('ios_message');
		if (device === 'android' && !JwtPayload) window.AndroidInterface?.startOauth();

		/* 有GR會員 但 token 效期已過的情況(只可能在 webview 下由 app team 放入token) => 利用 ios/Android team 提供方法轉導至 login 頁*/
		if (device === 'ios' && JwtPayload && isGrMember.isMember && isGrMember.expired)
			// window.webkit?.messageHandlers.startOauth.postMessage('ios_message');
			oAuthLogin();
		if (device === 'android' && JwtPayload && isGrMember.isMember && isGrMember.expired)
			// window.AndroidInterface?.startOauth();
			oAuthLogin();

		/* 有GR會員 且 token 效期內的情況 => 提供轉導至 member or 有效功能*/
		if (JwtPayload && isGrMember.isMember && !isGrMember.expired) {
			// 有輸入內部連結時才需轉導 外部連結需額外寫 a tag 連
			if (validLink.length > 0) history.push(validLink);
		} else if (
			JwtPayload &&
			!isGrMember.isMember &&
			!isGrMember.expired &&
			isGrMember.isMember !== undefined && // isMember 為 undefined 的話可能為造成401之外其他錯誤的非法 token, 詳見 getIsMember action
			isGrMember.expired !== undefined // isGrMember 為 undefined 的話可能為造成401之外其他錯誤的非法 token, 詳見 getIsMember action
		) {
			setShowModalMobile(true);
		} else {
			oAuthLogin();
		}
	};

	return (
		<div className={styles.footerBox}>
			<div className={styles.navBox}>
				<Link to="/" className={styles.linkBox}>
					<div className={styles.p}>FC 首頁</div>
				</Link>
				<div className={styles.br} />
				<a href="https://www.toyota.com.tw/toyotagazooracing/" className={styles.linkBox}>
					<div className={styles.p}>GR官網</div>
				</a>
				<div className={styles.br} />
				<a href="https://www.toyota.com.tw/contact.aspx" className={styles.linkBox}>
					<div className={styles.p}>聯絡我們</div>
				</a>
				<div className={styles.br} />
				<Link to="/questions" className={styles.linkBox}>
					<div className={styles.p}>常見問題</div>
				</Link>
				<div className={classNames(styles.br, styles.mobile)} />
				<a href="https://www.hotaimember.com.tw/" className={classNames(styles.linkBox, styles.mobile)}>
					<div className={styles.p}>和泰會員服務</div>
				</a>
				{/* 會員頁連結的各種情境： new */}
			</div>

			<div className={styles.customer}>
				<div className={styles.p}>客服專線 02-5599-7299 | 0800221345</div>
			</div>

			<div className={styles.copyRight}>
				<div className={styles.p}>©HOTAI MOTOR CO., LTD. 和泰汽車股份有限公司</div>
			</div>

			{/* mobile join member modal */}
			{showModalMobile && (
				<MemberJoinModalMobile
					onCloseClick={closeModalMobile}
					afterJoinMemberClick={closeModalMobile}
				/>
			)}

			{/* desktop join member modal */}
			{showModalDesktop && <MemberJoinModalDesktop onCloseClick={closeModalDesktop} />}
		</div>
	);
};

export default Footer;
